// Typelizer digest 5c587e7491e99c7a858415077713679b
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/ledger/batch_verification */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/batch_verification', {}, options),
    method: 'post',
  }),
}
